import React from "react";
import PropTypes from "prop-types";

// COMPONENTS
import Header from "../../../../../components/header/Header";
import UnsuccessfulSearchResultCards from "../../../reusableComponent/UnsuccessfulSearchResultCards";

// VALIDATIONS
import isEmptyVAL from "../../../../../validations/checks/isEmptyVAL";

// UTILITIES
import { transUTL } from "../../../../../utils/transUTL";

const BrazilTaxRegistration = ({ results, type }) => {
  if (isEmptyVAL(results[type])) return null;

  const data = results[type] ? results[type] : {};

  const { identityVerified, safeHarbourScore, addressMatchScore, nameMatchScore, verifications, status,
    errorMessage } = data;

  return (
    <div className="search-verification__results">
      <Header
        title={transUTL(
          "translateSearchVerification.dataSourcesBR.taxRegistration.title"
        )}
      />
      <div className="search-verification__verify">
        {
          status === 3
            ? <UnsuccessfulSearchResultCards errorMessage={errorMessage} />
            : <>
              <div className="search-verification__col">
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.safeHarbourScore"
                    )}
                  </p>
                  {!isEmptyVAL(safeHarbourScore) ? (
                    safeHarbourScore.toLowerCase() === "add" ? (
                      <span className="material-icons success">add_circle</span>
                    ) : (
                      <span>{safeHarbourScore}</span>
                    )
                  ) : (
                    <span>{transUTL("translateReuse.br")}</span>
                  )}
                </div>
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.verified"
                    )}
                  </p>
                  {!isEmptyVAL(identityVerified) ? (
                    identityVerified ? (
                      <span className="material-icons success">check_circle</span>
                    ) : (
                      <span className="material-icons error">cancel</span>
                    )
                  ) : (
                    <span>{transUTL("translateReuse.br")}</span>
                  )}
                </div>
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.addressMatchScore"
                    )}
                  </p>
                  {!isEmptyVAL(addressMatchScore) ? (
                    <span>{addressMatchScore}</span>
                  ) : (
                    <span>{transUTL("translateReuse.na")}</span>
                  )}
                </div>
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.nameMatchScore"
                    )}
                  </p>
                  {!isEmptyVAL(nameMatchScore) ? (
                    <span>{nameMatchScore}</span>
                  ) : (
                    <span>{transUTL("translateReuse.na")}</span>
                  )}
                </div>
              </div>
              <div className="search-verification__col">
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.fullName"
                    )}
                  </p>
                  {!isEmptyVAL(verifications.fullName) ? (
                    verifications.fullName ? (
                      <span className="material-icons success">check_circle</span>
                    ) : (
                      <span className="material-icons error">cancel</span>
                    )
                  ) : (
                    <span>{transUTL("translateReuse.na")}</span>
                  )}
                </div>
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.dateOfBirth"
                    )}
                  </p>
                  {!isEmptyVAL(verifications.dateOfBirth) ? (
                    verifications.dateOfBirth ? (
                      <span className="material-icons success">check_circle</span>
                    ) : (
                      <span className="material-icons error">cancel</span>
                    )
                  ) : (
                    <span>{transUTL("translateReuse.na")}</span>
                  )}
                </div>
                <div className="search-verification__verify-item">
                  <p>
                    {transUTL(
                      "translateSearchVerification.dataSourcesBR.taxRegistration.cpf"
                    )}
                  </p>
                  {!isEmptyVAL(verifications.cpf) ? (
                    verifications.cpf ? (
                      <span className="material-icons success">check_circle</span>
                    ) : (
                      <span className="material-icons error">cancel</span>
                    )
                  ) : (
                    <span>{transUTL("translateReuse.na")}</span>
                  )}
                </div>
              </div>
            </>
        }
      </div>
    </div>
  )

};

BrazilTaxRegistration.propTypes = {
  results: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
};

export default BrazilTaxRegistration;